import { render, staticRenderFns } from "./upgradeGet.vue?vue&type=template&id=2367b4ce&"
import script from "./upgradeGet.vue?vue&type=script&lang=js&"
export * from "./upgradeGet.vue?vue&type=script&lang=js&"
import style0 from "./upgradeGet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports